export default __webpack_public_path__ + "static/media/emotionsEvolution.60c4857a.png";